import React from 'react';
import { MetroSpinner } from 'react-spinners-kit';
import { useTheme } from 'styled-components/macro';

import * as S from './styles';

const FirstLoader: React.FC = () => {
  const theme = useTheme();

  return (
    <S.Wrapper>
      <MetroSpinner size={48} color={theme.colors.green.default} />
    </S.Wrapper>
  );
};

export default FirstLoader;
